import { useEffect } from 'react';
import { getWindow } from '../../../utils/getWindow';

const VIRTUAL_LIST_LS_KEY = 'virtual_list_save_params';
const SCROLL_DELAY = 50;

interface UseSaveListPositionParams {
    viewContainerRef: React.MutableRefObject<HTMLDivElement | null>;
    topHeightMapRef: React.MutableRefObject<{ [key: string]: number }>;
    scrollTopRef: React.MutableRefObject<number>;
    startIndex: number;
    endIndex: number;
    setIndexes: (params: { startIndex: number; endIndex: number }) => void;
}

export const useSaveListPosition = ({
    viewContainerRef,
    topHeightMapRef,
    scrollTopRef,
    setIndexes,
    startIndex,
    endIndex,
}: UseSaveListPositionParams) => {
    useEffect(() => {
        const currentWindow = getWindow();

        try {
            const stringifySaveParams = currentWindow?.sessionStorage.getItem(VIRTUAL_LIST_LS_KEY);

            if (stringifySaveParams) {
                const saveParams = JSON.parse(stringifySaveParams);
                topHeightMapRef.current = saveParams.topHeightMap;
                setIndexes({ startIndex: saveParams.startIndex, endIndex: saveParams.endIndex });

                currentWindow?.setTimeout(() => {
                    viewContainerRef.current?.scrollTo({ top: saveParams.scrollTop });
                }, SCROLL_DELAY);
            }
        } catch (e) {
            /* empty */
        }
    }, []);

    useEffect(
        () => () => {
            const currentWindow = getWindow();

            const saveParams = {
                topHeightMap: topHeightMapRef.current,
                scrollTop: scrollTopRef.current,
                startIndex: startIndex,
                endIndex: endIndex,
            };

            try {
                currentWindow?.sessionStorage.setItem(
                    VIRTUAL_LIST_LS_KEY,
                    JSON.stringify(saveParams),
                );
            } catch (e) {
                /* empty */
            }
        },
        [startIndex, endIndex],
    );

    useEffect(() => {
        const currentWindow = getWindow();

        if (!currentWindow) {
            return;
        }

        currentWindow.addEventListener(
            'pagehide',
            () => {
                try {
                    currentWindow?.sessionStorage.removeItem(VIRTUAL_LIST_LS_KEY);
                } catch (e) {
                    /* empty */
                }
            },
            false,
        );
    }, [startIndex, endIndex]);
};
